import { extendTheme, theme as defaultTheme, StyleFunctionProps, defineStyle, defineStyleConfig, withDefaultProps, cssVar, ComponentStyleConfig } from '@chakra-ui/react'
import { mode } from '@chakra-ui/theme-tools'
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import { MdLock } from 'react-icons/md';

export const NYIL_BTN = '➤'; // '➜➤⮞↝↗';
export const NYIL_UL = '•'; // '➜➤⮞↝';
export const NYIL_LINK = '↗'; // '➜➤⮞↝';
export const NYIL_BACK = '<'; //'⮜';
/*
export const TOKENS = {
    BG: 'bg',
    BRAND: 'brand',
    BRAND2: 'brand2',
    BRAND_HOVER: 'brand_hover',
}
*/

// 2. Extend the theme to include custom colors, fonts, etc

// paletta ötlet:  https://mycolor.space/?hex=%23008CC6&sub=1
// paletta gyakorlatban   https://palette.saas-ui.dev/
// kép ezzel sikerült:  https://designer.microsoft.com/image-creator

const colors = {
    /*[TOKENS.BRAND]: defaultTheme.colors.blue,
    [TOKENS.BRAND2]: defaultTheme.colors.green,
    [TOKENS.BRAND_HOVER]: defaultTheme.colors.blue,
    [TOKENS.BG]: '#d2ccc3',*/
    "cardbg": {
        "main": "#0b273f",
        "popup": "#0b273f",
    },
    "black": {
        50: '#000',
        100: '#000',
        200: '#000',
        300: '#000',
        400: '#000',
        500: '#000',
        600: '#000',
        700: '#000',
        800: '#000',
        900: '#000',
    },
    "primary": {
        "50": "#f1f9fc",
        "100": "#c6e5f2",
        "200": "#93cee7",
        "300": "#51b1d8",
        "400": "#299fcf",
        "500": "#0085bc",
        "600": "#00709f",
        "700": "#005a80",
        "800": "#004d6c",
        "900": "#00384f",
        "main": "#0096d3",
    },
    "secondary": {
        "600": "#f0f9f6",
        "500": "#c5e8dc",
        "400": "#90d3bd",
        "300": "#4cb895",

        //"200": "#33a681",
        "200": "#62bd9f",

        "100": "#2b8c6d",
        "80": "#25765c",
        "70": "#1d5f4a",
        "60": "#19503e",
        "50": "#123a2d",
        //"main": "#33a681",
        //"main": "#5dc0a1",
        //"main": "#1ab79b",
        "main": "#3ec18b",
    },
    "secondary.nincsmegforditva": {
        "50": "#f0f9f6",
        "100": "#c5e8dc",
        "200": "#90d3bd",
        "300": "#4cb895",
        "400": "#33a681",
        "500": "#2b8c6d",
        "600": "#25765c",
        "700": "#1d5f4a",
        "800": "#19503e",
        "900": "#123a2d",
        "main": "#33a681",
    }
}

// define the base component styles
const $arrowBg = cssVar("popper-arrow-bg");
const baseStyle = {
    borderRadius: 'md', // add a border radius
    fontWeight: 'normal', // change the font weight
    bg: '#90d3bd', // add a border
    [$arrowBg.variable]: '#90d3bd', // add a border
    color: '#000',
    boxShadow: 'xl'

}
const tooltipTheme = defineStyleConfig({ baseStyle })


window.localStorage.setItem('chakra-ui-color-mode', 'dark'); // kristóf féle 

// dark-lg helyett:  1px 3px 13px -3px #000
export const deepTheme = extendTheme({
    initialColorMode: 'dark',
    useSystemColorMode: false,
    fonts: {
        heading: `'Roboto', sans-serif`,
        body: `'Roboto', sans-serif`,

        //heading: `BourtonBase, 'Roboto', sans-serif`,
        //body: `Titillium Web,sans-serif`,

        overflow: 'hidden',

    },
    colors,
    shadows: {
        vvcard: "1px 3px 13px -3px #000",
        vvtitle: "0px 1px 6px -2px #000",
    },
    /*semanticTokens: {
        shadows: {
            vvtitle: {
                value: {
                    _light: "1px 3px 13px -3px #000",
                    _dark: "1px 3px 13px -3px #000",
                },
            },
            vvcard: {
                value: {
                    _light: "1px 3px 13px -3px #000",
                    _dark: "1px 3px 13px -3px #000",
                },
            },
        },
    },*/
    styles: {
        global: (props: StyleFunctionProps) => ({
            "body": {
                minHeight: '100vh',
                height: '100vh',
                p: 0, m: 0,
                overscrollBehaviorY: 'contain',
                //bg: mode('gray.100', 'gray.800')(props),
                //bg: mode('gray.100', '#0b273f')(props),
                //bg: "red",
                bg: "#bbb",
            },
            '.grecaptcha-badge': {
                visibility: 'hidden',
            },
            '.hover-bg:hover': {
                bg: mode('gray.100', 'gray.800')(props),
            },
            '.hover-bg.selected': {
                bg: mode('gray.200', 'gray.700')(props),
            },
            '.doleft .chakra-modal__content-container': {
                justifyContent: 'flex-start !important',
                paddingInline: '2rem',
                width: 'auto !important',
                border: '0px solid red',
            },
            'h1': {
                color: '#008CC6',
                fontSize: '2rem !important',
                fontWeight: 'medium',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
            },
            ".menuactive > h2": {
                background: "secondary.main",
                color: '#000',
            },
            ".chakra-form__label": {
                color: " #79c6e5",
                marginBottom: '0 !important',
                lineHeight: 'normal',
                marginTop: '1em !important',
                fontWeight: '400 !important',
            },
            '.popupart': {
                lineHeight: '1.85em',
                //fontSize: 'large',
                fontWeight: '300',
            },

            '.popupart b, .popupart u': {
                fontWeight: '500',
                textDecoration: 'none',
                _before: {
                    content: '" \\00a0"'
                },
                _after: {
                    content: '"\\00a0 "'
                },
            },
            '.popupart b': {
                color: '#54dbb0',
            },
            '.popupart b.red': {
                color: '#db4545',
            },
            '.popupart u': {
                color: '#9bd981',
            },
            '.popupart i': {
                background: '#ffffffd0',
                color: '#000',
                display: 'inline-block',
                lineHeight: 'normal',
                padding: '0px 3px',
                borderRadius: 'sm',
                fontWeight: '500',
            },
            '.popupart a.xx1': {
                fontWeight: '500',
                display: 'inline-block',
                background: '#0000',
                padding: '0px 3px',
                color: '#3ac6ff',
                lineHeight: 'normal',
                borderRadius: 'sm',
                borderBottom: '1px dashed #008cc6bf',
                '_after': {
                    //content: '" ↪"',
                    content: '" ↗"',
                },
                _hover: {
                    textDecoration: 'none',
                    background: '#0006',
                    transform: 'translate(1px, -2px)',
                    //background: 'primary.600',
                    //color: '#fff',
                },
            },
            '.popupart .xx2': {
                fontWeight: '500',
                display: 'inline-flex',
                alignItems: 'baseline',
                mx: 1,
                //background: '#3093bc',
                background: '#1b354cdb',
                padding: '1px .6em',
                color: '#5ad2ff',
                lineHeight: 'normal',
                borderRadius: '4px',
                '_after': {
                    content: '" ' + NYIL_LINK + '"',
                    fontFamily: 'initial',
                },
                _hover: {
                    textDecoration: 'none',
                    transform: 'translate(1px, -2px)',
                    boxShadow: 'md',
                },
            },
            '.popupart .xx3': {
                fontWeight: '500',
                display: 'inline-flex',
                alignItems: 'baseline',
                mx: 1,
                color: '#000',
                background: '#3ec18b',
                borderRadius: 0,
                padding: '1px .6em',
                lineHeight: 'normal',
                '_after': {
                    content: '" ' + NYIL_LINK + '"',
                    fontFamily: 'initial',
                },
                _hover: {
                    textDecoration: 'none',
                    transform: 'translate(1px, -2px)',
                    boxShadow: 'md',
                },
            },

            '.popupart ul': {
                marginLeft: '1em',
            },
            '.popupart ul li': {
                listStyleType: '"' + NYIL_UL + '\\00a0\\00a0"',
            },
            '.popupart ul li::marker': {
                //color: '#ffffff15',
                color: '#30b9d9cf',
                fontFamily: 'initial',
            },

            '.body-not-mobile .popupart ul.ulbox': {
                //paddingLeft: 1,
            },
            '.body-mobile .popupart ul.ulbox': {
                paddingLeft: 0,
            },
            '.popupart ul.ulbox > li': {
                listStyleType: 'none',
                marginBottom: '20px',
                marginRight: '12px',
                padding: '6px 1em',
                display: 'inline-block',
                //background: 'linear-gradient(195deg, #ffffff0a, transparent)',
                //borderRadius: '6px',
                //boxShadow: '2px 2px 3px -3px #000000ad',
            },
            '.body-mobile .popupart ul.ulbox > li': {
                background: 'none',
            },

            '.popupart ul.ulbox > li:before': {
                content: '"' + NYIL_UL + '\\00a0\\00a0"',
                color: '#ffffff33',
                fontFamily: 'initial',
            },

        })
    },

    components: {
        Button: {
            sizes: {
                md: {
                    borderRadius: 0,
                }
            },
            variants: {
                'admin': {
                    //bg: '',
                    color: 'red.400',
                    border: '1px solid red.400',
                    baseStyle: 'outline',
                    //boxShadow: '0 0 2px 2px #efdfde',
                },
            },            
        },
        Tooltip: tooltipTheme,
    }
},


    withDefaultProps({
        defaultProps: {

            borderRadius: 0, // nem működik :(
        },
        components: ['Button'],
    })

);